import {
  BOOK_TOUR, BOOK_TOUR_FAIL,
  FETCH_TOUR, FETCH_TOUR_FAIL,
  UPDATE_TOUR_INFORMATION_LOADING, UPDATE_TOUR_INFORMATION, UPDATE_TOUR_INFORMATION_FAIL,
  DELETE_TOUR_INFORMATION, DELETE_TOUR_INFORMATION_FAIL,
  ADD_TOUR_INFORMATION, ADD_TOUR_INFORMATION_FAIL,
  FETCH_ITINERARIES
} from './types';
import { SLACK_WEBHOOKS } from '../config';
import axios from 'axios';
import { history } from '../components/app';
import { SetBooking } from './currentBooking';
import { SlackWebhook } from './utils';
import { PostIntinerariesAccomodation  } from './itineraries';


export function BookingError(){
  return (dispatch) => {
    dispatch(SetBooking(false));
    dispatch({type:BOOK_TOUR_FAIL, payload:true})
  }
}


/**
 * Initial booking creation
 * Book Tour (Holds booking) via Busabout API
 * For CYOA tours - intercept_type is set to builder.
 *
 * @param {string} currency - iso currency (GBP, AUD, USD, CAD).
 * @param {string} payload - booking payload
 * @param {string} basketType - if the basket is from the busabout booking or the product page
 * @param {string} emailConsent - if email consent
 * @param {string} iscyoa - if tour is CYOA
 */
export function BookTour(currency, payload, basketType, emailConsent, iscyoa){

  const IS_CYOA = (iscyoa) ? '&request_type=builder' : '';
  const bookingURL = `${process.env.REACT_APP_BOOKING_API}?currency=${currency}&api_token=${process.env.REACT_APP_API_TOKEN}&email_consent=${emailConsent}${IS_CYOA}`;

  const config = {
    headers:{
      'Content-Type': 'text/plain'
    },
    withCredentials: true
  };

  return async dispatch => {
    try{
      const response = await axios.post(bookingURL, payload, config);

      //console.log(response)
      dispatch({type:BOOK_TOUR});
      if(response.data){
        //console.log('booking success - group booking id', JSON.stringify(response.data) );
        //dispatch({type:SET_BOOKING_GROUP, payload:response.data});
        dispatch(SetBooking(false));

        if(!iscyoa){
          window.location.href = `${process.env.REACT_APP_WWW_BOOKING_URL}/paymentdetails/${response.data.group_booking_id}`;
        }else{
          window.location.href = `${process.env.REACT_APP_WWW_DISCOVERY_URL}${process.env.REACT_APP_ITINERARY_PAGE}?id=${response.data.cyoa_token}`;
        }
      }
    }
    catch(err){
      console.error(err);
      dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! BOOKING API (POST) - '  + bookingURL + " " + err}));
      history.push('/500');
      dispatch({type:BOOK_TOUR_FAIL, payload:false})
    };
  }
}



/**
 * Get booking information
 * Fetch booking via Busabout API
 *
 * @param {string} bookingId - booking id number
 */
export function FetchBooking(bookingId){

  const bookingURL = `${process.env.REACT_APP_BOOKING_API}/${bookingId}?api_token=${process.env.REACT_APP_API_TOKEN}&booking_id=${bookingId}&request_type=builder_fetch`;

  return async dispatch => {
    try{
      const response = await axios.get(bookingURL, {withCredentials: true});
      dispatch({type:FETCH_TOUR, payload:response.data});
    }
    catch(err){
      console.error(err);
      dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! Booking API (GET) - ' + bookingURL + " " + err}));
      history.push('/500');
      dispatch({type:FETCH_TOUR_FAIL});
    }
  }
}


/**
 * Update trip information via Busabout API [updated]
 *
 * @param {string} bookingId - booking id number
 * @param {string} requestType - request type (passenger_update, add_sectors, update_sectors, update_trip)
 * @param {string} payload - booking payload
 */
 export function UpdateTripInfo(bookingId, requestType, payload){

  const config = {
     headers:{
       'Content-Type': 'text/plain'
     },
     withCredentials: true
  };

  const HAS_PASSENGER_REQUEST_TYPE = (requestType === "passengers_update") ? '&lead=1' : '';
  const bookingURL = `${process.env.REACT_APP_BOOKING_API}/${bookingId}?api_token=${process.env.REACT_APP_API_TOKEN}&booking_id=${bookingId}&request_type=${requestType}${HAS_PASSENGER_REQUEST_TYPE}&new_response=1`;

  return async dispatch => {

    dispatch({type:UPDATE_TOUR_INFORMATION_LOADING, payload:true});

    try{
      const response = await axios.put(bookingURL, payload, config);
	
      if(response.data){
       const fetchIntinerariesResponse = await dispatch({type:FETCH_ITINERARIES, payload:response.data});    
       dispatch(PostIntinerariesAccomodation(fetchIntinerariesResponse.payload.data, true, true, (fetchIntinerariesResponse.payload.data.accomm_global_room_type === "none" ? false : true), fetchIntinerariesResponse.payload.data.accomm_global_room_type));
       dispatch({type:UPDATE_TOUR_INFORMATION, payload:false});
       return Promise.resolve();
      }
    }
    catch(err){
      console.error(err);
      dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! Booking API (PUT) - ' + bookingURL + " " + err}));
      history.push('/500');
      dispatch({type:UPDATE_TOUR_INFORMATION_FAIL, payload:false});
    }

  }

 }


 /**
  * Delete trip information via Busabout API
  *
  * @param {string} bookingId - booking id number
  * @param {string} requestType - request type (remove_sectors, remove_trips, remove_passenger_trips)
  * @param {string} payload - booking payload
  */
  export function DeleteTripInfo(bookingId, requestType, payload){

   const config = {
      headers:{
        'Content-Type': 'text/plain'
      },
      withCredentials: true,
      data:payload
   };

   const bookingURL = `${process.env.REACT_APP_BOOKING_API}/${bookingId}?api_token=${process.env.REACT_APP_API_TOKEN}&booking_id=${bookingId}&request_type=${requestType}&new_response=1`;


   return async dispatch => {

    dispatch({type:UPDATE_TOUR_INFORMATION_LOADING, payload:true});

    try{
      const response = await axios.delete(bookingURL, config);

       if(response.data){
        const fetchIntinerariesResponse = await dispatch({type:FETCH_ITINERARIES, payload:response.data});    
        dispatch(PostIntinerariesAccomodation(fetchIntinerariesResponse.payload.data, true, true, (fetchIntinerariesResponse.payload.data.accomm_global_room_type === "none" ? false : true), fetchIntinerariesResponse.payload.data.accomm_global_room_type));
        dispatch({type:DELETE_TOUR_INFORMATION, payload:false});
        return Promise.resolve();
       }
    }
     catch(err){
       console.error(err);
       dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! Booking API (PUT) - ' + bookingURL + " " + err}));
       history.push('/500');
       dispatch({type:DELETE_TOUR_INFORMATION_FAIL, payload:false});
     }

   }

  }


  /**
   * Add trip information via Busabout API
   *
   * @param {string} bookingId - booking id number
   * @param {string} requestType - request type (add_passenger_trips, add_trips)
   * @param {string} payload - booking payload
   */
   export function AddTripInfo(bookingId, requestType, payload){

    const config = {
       headers:{
         'Content-Type': 'text/plain'
       },
       withCredentials: true
    };

    const bookingURL = `${process.env.REACT_APP_BOOKING_API}/${bookingId}?api_token=${process.env.REACT_APP_API_TOKEN}&booking_id=${bookingId}&request_type=${requestType}&new_response=1`;

    return async dispatch => {
      dispatch({type:ADD_TOUR_INFORMATION, payload:true});
      try{
        const response = await axios.post(bookingURL, payload, config);

        if(response.data){
          const fetchIntinerariesResponse = await dispatch({type:FETCH_ITINERARIES, payload:response.data});    
          dispatch(PostIntinerariesAccomodation(fetchIntinerariesResponse.payload.data, true, true, (fetchIntinerariesResponse.payload.data.accomm_global_room_type === "none" ? false : true), fetchIntinerariesResponse.payload.data.accomm_global_room_type));
          dispatch({type:ADD_TOUR_INFORMATION, payload:false});
          return Promise.resolve();
        }
      }
      catch(err){
        console.error(err);
        dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! Booking API (DELETE) - ' + bookingURL + " " + err}));
        history.push('/500');
        dispatch({type:ADD_TOUR_INFORMATION_FAIL, payload:false});
      }

    }
}



// WEBPACK FOOTER //
// ./src/actions/booking.js